import React, { Component,Fragment } from 'react'

class CheckBoxGroup extends React.Component{
    

    checkBoxGroup(){
        	let {label, required, options,maxOptions, input, meta} = this.props;
                                    
            return options.map((option, index) => {
                return(
                        <div key={index}>
                            <label className="inline normal checkbox-container">
                                <input
                                    name={`${input.name}[${index}]`}
                                    value={option}
                                    type="checkbox"
                                    checked={input.value.indexOf(option) !== -1}
                                    onChange={(event) => {
                                            const newValue = [...input.value] || [];
                                            if (event.target.checked) {
                                                if (maxOptions) {
                                                    if (input.value.length == maxOptions) {
                                                        newValue.splice(0, 1);
                                                        newValue.push(option);
                                                    }else{
                                                        newValue.push(option);
                                                    }
                                                }else{
                                                    
                                                    if (input.value.length > 0) {
                                                        newValue.splice(0,1);
                                                        newValue.push(option);
                                                        
                                                    }else{
                                                        newValue.push(option);
                                                    }
                                                }
                                                
                                                    
                                            } else {
                                                    newValue.splice(newValue.indexOf(option), 1);
                                            }

                                            return input.onChange(newValue);
                                    }}/>{option}<span className="checkmark"></span>
                            </label>
                        </div>
                )
            })
    }

    render(){
        return(
            <div className="align-items-center checkbox-purple-div-big">
            {this.checkBoxGroup()}
            </div>
        )
    }
}

export default CheckBoxGroup